import DialogContent from '@mui/material/DialogContent';

export { DialogContent };
